import React from 'react';

import { blockInfoGraphicType, blockLimitedHoldingsSubjectsWithFees, showBlockChangesColumn } from 'venn-state';
import { useRecoilValue, useRecoilState } from 'recoil';
import { SmallSwitch } from '@/components/ui/small-switch';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface ShowColumnChangesToggleProps {
  selectedRefId: string;
}

export const ShowColumnChangesToggle = ({ selectedRefId }: ShowColumnChangesToggleProps) => {
  const infoGraphicType = useRecoilValue(blockInfoGraphicType(selectedRefId));
  const subjects = useRecoilValue(blockLimitedHoldingsSubjectsWithFees(selectedRefId));

  const [showChangesColumn, setShowChangesColumn] = useRecoilState(showBlockChangesColumn(selectedRefId));

  const handleToggleColumnChanges = () => {
    setShowChangesColumn(!showChangesColumn);
  };

  const isDisabled = infoGraphicType !== 'GRID' || subjects.length !== 2;

  return (
    <div className="flex flex-wrap flex-row justify-between items-center">
      <div className="text-[14px] font-bold">Show "Changes" Column</div>
      {isDisabled ? (
        <Tooltip>
          <TooltipTrigger>
            <SmallSwitch
              checked={showChangesColumn}
              onCheckedChange={handleToggleColumnChanges}
              disabled={isDisabled}
              data-testid="show-column-changes-toggle"
            />
          </TooltipTrigger>
          <TooltipContent side="top">
            {infoGraphicType !== 'GRID'
              ? '"Changes" column is only available for grid infographic type.'
              : '"Changes" column is only available when two subjects are assigned to this block.'}
          </TooltipContent>
        </Tooltip>
      ) : (
        <SmallSwitch
          checked={showChangesColumn}
          onCheckedChange={handleToggleColumnChanges}
          disabled={isDisabled}
          data-testid="show-column-changes-toggle"
        />
      )}
    </div>
  );
};
